import { CourseEntry } from '@/models';
import { IValidator, isYearValid } from '@/models/validation/IValidator';

export class CourseEntryValidator implements IValidator<CourseEntry> {
	public isNullOrWhitespace(val: string | null) {
		return (val || '').trim() === '';
	}

	public isValid(val: CourseEntry): boolean {
		return !(val.academicTerm == null
			|| !isYearValid(val.academicYear)
			|| val.course.value == null
			|| this.isNullOrWhitespace(val.institution.value));
	}
}

export default new CourseEntryValidator();
